import { useEffect } from 'react';
import pageMessageBroker from './page_message_broker';

export function usePageMessageBrokerListener(messageName, callback) {
  useEffect(() => {
    const handler = (e) => callback(e.detail);

    const subscription = pageMessageBroker.subscribe(messageName, handler);
    return () => {
      subscription.unsubscribe();
    };
  }, [messageName, callback]);
}
